import { render, staticRenderFns } from "./CallInfo.vue?vue&type=template&id=b45014d4&scoped=true&"
import script from "./CallInfo.vue?vue&type=script&lang=js&"
export * from "./CallInfo.vue?vue&type=script&lang=js&"
import style0 from "./CallInfo.vue?vue&type=style&index=0&id=b45014d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45014d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
